import BetReturnText from './BetReturnText';

export default BetReturnText;
